'use client'
import Image from 'next/image'

import { FC } from 'react'

import { AnimationMoveIconComponent } from '@/app/shared/components/animation/move-icon'
import { AnimationShowBlockComponent } from '@/app/shared/components/animation/show-block'
import { LessonFormComponent } from '@/app/shared/components/sign-up-lesson/elements/lesson-form'
import { IconBgPart } from '@/app/shared/icons'
import { IId } from '@/app/shared/interfaces/common.interface'
import {
  IButton,
  IDescription,
  ISticker,
  ISubTitle,
  ITitle,
} from '@/app/shared/interfaces/content.interface'
import { ITypeSite } from '@/app/shared/store/layout.store'
import { ContainerComponent } from '@/app/shared/ui/container'
import { TitleComponent } from '@/app/shared/ui/title'

// interface
interface ISignUpLesson extends IId {
  data: ISignUpLessonQuery
  typeSite: ITypeSite | null
}

export interface ISignUpLessonQuery {
  title: ITitle
  subTitle: ISubTitle
  button: IButton
  sticker: ISticker[]
  description: IDescription
}

// component
const SignUpLessonComponent: FC<Readonly<ISignUpLesson>> = ({ data, id, typeSite }) => {
  // return
  return (
    <ContainerComponent id={id}>
      <div
        className={
          'relative bg-content1-200 p-[30px] extraMobile:p-10 laptop:p-[60px_80px_60px_50px]'
        }
      >
        <div
          className={
            'grid grid-cols-1 gap-[50px] laptop:grid-cols-[1fr_370px] laptop:gap-[50px] desktop:grid-cols-[1fr_490px] large:grid-cols-[1fr_680px]'
          }
        >
          <div className={'grid gap-[60px] laptop:gap-[40px]'}>
            <div className={'flex flex-wrap justify-between extraMobile:flex-nowrap'}>
              <TitleComponent
                className={'leading-none text-success large:w-2/4'}
                animate
                classSize={'text-[28px] extraMobile:text-[34px]'}
              >
                {data.title.title}
              </TitleComponent>
              <AnimationMoveIconComponent
                className={
                  'relative h-[94px] w-[80px] flex-shrink-0 mobile:self-center laptop:self-end large:h-[114px] large:w-[97px] large:self-start'
                }
                initial={{
                  opacity: 0,
                }}
                whileInView={{
                  opacity: 1,
                }}
              >
                <Image
                  src={data.sticker[0]?.image}
                  alt={'img'}
                  fill
                  className={'object-cover'}
                  sizes={'(max-width: 1920px):80px, 97px'}
                />
              </AnimationMoveIconComponent>
            </div>
            <AnimationShowBlockComponent
              typeTag={'span'}
              className={'text-[18px] laptop:w-2/4 desktop:text-[22px]'}
              initial={{
                opacity: 0,
                x: -20,
              }}
              whileInView={{
                opacity: 1,
                x: 0,
              }}
            >
              {data.subTitle.subTitle}
            </AnimationShowBlockComponent>
          </div>
          <AnimationShowBlockComponent
            initial={{
              opacity: 0,
              x: 20,
            }}
            whileInView={{
              opacity: 1,
              x: 0,
            }}
          >
            <LessonFormComponent data={data} typeSite={typeSite} />
          </AnimationShowBlockComponent>
        </div>
        <AnimationMoveIconComponent
          className={
            'absolute bottom-[25px] hidden h-[89px] w-[128px] tablet:right-0 laptop:right-[50px] laptop:block large:h-[115px] large:w-[164px]'
          }
          valueMoving={55}
          initial={{
            opacity: 0,
          }}
          whileInView={{
            opacity: 1,
          }}
        >
          <Image
            src={data.sticker[1]?.image}
            alt={'img'}
            fill
            className={'object-cover'}
            sizes={'(max-width: 1920px):128px, 164px'}
          />
        </AnimationMoveIconComponent>
        <IconBgPart
          className={'absolute -top-[36px] right-0 h-[37px] w-[53px] text-content1-200'}
        />
      </div>
    </ContainerComponent>
  )
}

export default SignUpLessonComponent
